import {Factory as IntegerMaskFactory} from "../src/TelephoneInput/IntegerMask/Factory";

export const Providers = [
    IntegerMaskFactory
];
